"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ethereumjsCommon = _interopRequireDefault(require("ethereumjs-common"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var commonGenerator = function commonGenerator(network) {
  var customCommon = _ethereumjsCommon.default.forCustomChain('mainnet', {
    name: network.name_long,
    chainId: network.chainID
  });

  return new _ethereumjsCommon.default(customCommon._chainParams, 'petersburg', ['petersburg']);
};

var _default = commonGenerator;
exports.default = _default;